import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  SocialMediaGoals,
  SocialMediaAudience,
  SocialMediaPlatforms,
  SocialMediaMetrices,
  SocialMediaContent,
  SocialMediaPosts,
} from "../../../app-constants-updated";
import BgImg from "../../images/services-usa/social-media/social_media_success.webp";
import { Link } from "gatsby";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Social Media Marketing Road Map: How We{" "}
              <span>Help You Succeed</span>
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>
                    Set Clear
                    <br className="d-none d-md-block" /> Goals
                  </h5>
                </div>
                <div className="ecom_box_icon">{SocialMediaGoals}</div>
              </div>
              <p>
                We collaborate with you to define specific objectives, and set
                clear goals, whether it involves increasing brand awareness,
                generating leads, or boosting sales. Establishing clear goals
                ensures that every effort is fully aligned with your business
                vision.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>
                    Research your <br className="d-none d-md-block" /> Target
                    Audience
                  </h5>
                </div>
                <div className="ecom_box_icon">{SocialMediaAudience}</div>
              </div>
              <p>
                We dive deep into understanding your ideal customers—their
                demographics, interests, and online behaviors—so we can
                carefully tailor a strategy that speaks directly to them.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>
                    Determine Social Media Platforms Aligned with Your Brand
                  </h5>
                </div>
                <div className="ecom_box_icon">{SocialMediaPlatforms}</div>
              </div>
              <p>
                Our team identifies the social media platforms that align with
                your brand and audience. We ensure your business is visible
                where it matters the most, ensuring your message reaches to the
                right people through the right medium.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>
                    Set Metrics and <br className="d-none d-md-block" /> KPIs
                  </h5>
                </div>
                <div className="ecom_box_icon">{SocialMediaMetrices}</div>
              </div>
              <p>
                As a competent social media management company, we set
                benchmarks that are easily measurable like engagement rates,
                follower growth, and conversions. These KPIs help us track
                success and adjust real-time strategies to maximize your ROI.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>
                    Create Engaging <br className="d-none d-md-block" /> Content
                  </h5>
                </div>
                <div className="ecom_box_icon">{SocialMediaContent}</div>
              </div>
              <p>
                We craft compelling content that captures your brand’s identity
                and also resounds with your audience. Our team ensures a mix of
                visuals, videos, and posts that drive interaction with a loyal
                community.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>
                    Schedule Posts on <br className="d-none d-md-block" />{" "}
                    Social Media
                  </h5>
                </div>
                <div className="ecom_box_icon">{SocialMediaPosts}</div>
              </div>
              <p>
                We handle the scheduling of your content, making sure it’s
                posted at optimal times to maximize reach and engagement. Our
                goal is to keep reminding your audiences about your brand at
                regular intervals.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
